define('customPlugins/atnKendoNumericTextBox',[
        'knockout', 'lodash', 'jquery', 'kendo-knockout',
    ],
    function(ko, _, $) {
        'use strict';

        ko.bindingHandlers.atnKendoNumericTextBox = {
            init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
                ko.bindingHandlers.kendoNumericTextBox.init(element, valueAccessor, allBindings, viewModel, bindingContext);

                var numerictextbox = $(element).data('kendoNumericTextBox');

                _.defer(function() {
                    $(element).on('cut paste keydown blur', onDeferredChange);
                    $(element).next().on('click', onDeferredChange);
                    numerictextbox.bind('change', onChange);
                });

                function onDeferredChange() {
                    _.defer(onChange);
                }

                function onChange() {
                    var number = parseInt(element.value, 10),
                        options = numerictextbox.options;
                    number = _.isNaN(number) ? null : number;
                    element.value = _.isNumber(number) ? number.toString() : '';
                    valueAccessor().value(number);
                }
            },
            update: ko.bindingHandlers.kendoNumericTextBox.update
        };
    });
